import React from 'react';
import InlineSVG from 'svg-inline-react';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

const svgLogoSource = '<svg viewBox="0 0 300 26.845" xmlns="http://www.w3.org/2000/svg"><path d="m256.681 302.362a12.855 12.855 0 0 1 -5.042-4.783 13.942 13.942 0 0 1 0-13.83 12.868 12.868 0 0 1 5.042-4.783 16.087 16.087 0 0 1 13.311-.537 12.217 12.217 0 0 1 4.579 3.411l-3.856 3.56a8.29 8.29 0 0 0 -6.526-3.041 8.668 8.668 0 0 0 -4.3 1.057 7.515 7.515 0 0 0 -2.947 2.947 9.28 9.28 0 0 0 0 8.6 7.509 7.509 0 0 0 2.947 2.947 8.659 8.659 0 0 0 4.3 1.057 8.248 8.248 0 0 0 6.526-3.078l3.856 3.56a12.014 12.014 0 0 1 -4.6 3.449 15.275 15.275 0 0 1 -6.118 1.186 14.9 14.9 0 0 1 -7.172-1.722z" fill="#ffa900" transform="translate(-249.803 -277.241)"/><path d="m287.041 302.344a12.919 12.919 0 0 1 -5.08-4.8 13.8 13.8 0 0 1 0-13.757 12.944 12.944 0 0 1 5.08-4.8 16.062 16.062 0 0 1 14.553 0 13.238 13.238 0 0 1 0 23.36 16.062 16.062 0 0 1 -14.553 0zm11.439-4.431a7.592 7.592 0 0 0 2.91-2.947 9.281 9.281 0 0 0 0-8.6 7.6 7.6 0 0 0 -2.91-2.947 8.686 8.686 0 0 0 -8.306 0 7.6 7.6 0 0 0 -2.911 2.947 9.288 9.288 0 0 0 0 8.6 7.588 7.588 0 0 0 2.911 2.947 8.686 8.686 0 0 0 8.306 0z" fill="#ffa900" transform="translate(-253.504 -277.241)"/><path d="m341.432 277.748v25.952h-4.932l-12.94-15.755v15.755h-5.932v-25.952h4.972l12.9 15.759v-15.759z" fill="#ffa900" transform="translate(-258.08 -277.303)"/><path d="m356.72 282.643h-8.306v-4.895h22.618v4.895h-8.306v21.057h-6.006z" fill="#ffa900" transform="translate(-261.838 -277.303)"/><path d="m392.993 298.142h-12.051l-2.3 5.562h-6.155l11.569-25.956h5.932l11.607 25.952h-6.3zm-1.891-4.561-4.116-9.937-4.116 9.938z" fill="#ffa900" transform="translate(-264.776 -277.303)"/><g fill="#940742"><path d="m413.321 302.362a12.855 12.855 0 0 1 -5.042-4.783 13.943 13.943 0 0 1 0-13.83 12.869 12.869 0 0 1 5.042-4.783 16.087 16.087 0 0 1 13.311-.537 12.218 12.218 0 0 1 4.579 3.411l-3.856 3.56a8.292 8.292 0 0 0 -6.526-3.041 8.67 8.67 0 0 0 -4.3 1.057 7.515 7.515 0 0 0 -2.947 2.947 9.281 9.281 0 0 0 0 8.6 7.509 7.509 0 0 0 2.947 2.947 8.661 8.661 0 0 0 4.3 1.057 8.249 8.249 0 0 0 6.526-3.078l3.856 3.56a12.017 12.017 0 0 1 -4.6 3.449 15.28 15.28 0 0 1 -6.118 1.186 14.9 14.9 0 0 1 -7.172-1.722z" transform="translate(-268.92 -277.241)"/><path d="m443.681 302.344a12.921 12.921 0 0 1 -5.081-4.8 13.816 13.816 0 0 1 0-13.757 12.946 12.946 0 0 1 5.081-4.8 16.063 16.063 0 0 1 14.553 0 13.238 13.238 0 0 1 0 23.36 16.062 16.062 0 0 1 -14.553 0zm11.438-4.431a7.573 7.573 0 0 0 2.91-2.947 9.281 9.281 0 0 0 0-8.6 7.58 7.58 0 0 0 -2.91-2.947 8.686 8.686 0 0 0 -8.305 0 7.578 7.578 0 0 0 -2.91 2.947 9.274 9.274 0 0 0 0 8.6 7.572 7.572 0 0 0 2.91 2.947 8.685 8.685 0 0 0 8.305 0z" transform="translate(-272.621 -277.241)"/><path d="m497.887 303.7-.037-15.574-7.638 12.83h-2.712l-7.6-12.5v15.244h-5.636v-25.952h4.968l9.715 16.129 9.566-16.129h4.932l.074 25.956z" transform="translate(-277.197 -277.303)"/><path d="m514.6 277.748h6.006v25.952h-6.006z" transform="translate(-282.12 -277.303)"/><path d="m545.763 290.256h5.487v10.531a15.684 15.684 0 0 1 -4.894 2.447 19.023 19.023 0 0 1 -5.6.853 15.168 15.168 0 0 1 -7.269-1.724 12.829 12.829 0 0 1 -5.061-4.783 13.947 13.947 0 0 1 0-13.83 12.776 12.776 0 0 1 5.1-4.783 15.47 15.47 0 0 1 7.341-1.724 16.067 16.067 0 0 1 6.192 1.15 12.271 12.271 0 0 1 4.673 3.337l-3.857 3.559a8.92 8.92 0 0 0 -6.712-2.93 9.164 9.164 0 0 0 -4.412 1.039 7.456 7.456 0 0 0 -3 2.929 9.22 9.22 0 0 0 0 8.64 7.6 7.6 0 0 0 2.985 2.947 8.842 8.842 0 0 0 4.357 1.057 9.743 9.743 0 0 0 4.672-1.112z" transform="translate(-283.583 -277.241)"/><path d="m566.07 302.344a12.92 12.92 0 0 1 -5.08-4.8 13.81 13.81 0 0 1 0-13.757 12.944 12.944 0 0 1 5.08-4.8 16.062 16.062 0 0 1 14.553 0 13.237 13.237 0 0 1 0 23.36 16.062 16.062 0 0 1 -14.553 0zm11.439-4.431a7.578 7.578 0 0 0 2.91-2.947 9.281 9.281 0 0 0 0-8.6 7.585 7.585 0 0 0 -2.91-2.947 8.686 8.686 0 0 0 -8.306 0 7.581 7.581 0 0 0 -2.911 2.947 9.281 9.281 0 0 0 0 8.6 7.575 7.575 0 0 0 2.911 2.947 8.686 8.686 0 0 0 8.306 0z" transform="translate(-287.557 -277.241)"/><path d="m409.812 300.478-27.739-.064 1.927-4.651 25.874-.009z" transform="translate(-265.946 -279.501)"/></g></svg>';

const network = [
  {
    id: '1',
    url: 'temp-persona-1.jpg',
  },
  {
    id: '2',
    url: 'temp-persona-2.jpg',
  },
  {
    id: '3',
    url: 'temp-persona-3.jpg',
  },
  {
    id: '4',
    url: 'temp-persona-4.jpg',
  },
  {
    id: '5',
    url: 'temp-persona-5.jpg',
  },
  {
    id: '6',
    url: 'temp-persona-6.jpg',
  },
  {
    id: '7',
    url: 'temp-persona-7.jpg',
  },
  {
    id: '8',
    url: 'temp-persona-8.jpg',
  },
  {
    id: '9',
    url: 'temp-persona-9.jpg',
  },
  {
    id: '10',
    url: 'temp-persona-10.jpg',
  },
  {
    id: '11',
    url: 'temp-persona-11.jpg',
  },
  {
    id: '12',
    url: 'temp-persona-12.jpg',
  },
];

const NaoEncontrado = () => {

  const width = window.screen.availWidth;

  return (

    <section className="section -cover b-4 notfound -wrap" name="facaparte">

      { width >= 992 && 

        <article className="notfound -network -content">

          <div className="notfound -network -list -left">

            { network && network.slice(0, 6).map( (image,index) => {

              return (

                <div className="notfound -network -item" key={index}>
                  <img src={require('../../assets/images/temp/' + image.url)} alt="Rede Solidária" />
                </div>
              );
            })}

          </div>

          <div className="notfound -network -list -right">

            { network && network.slice(6, 12).map( (image,index) => {

              return (

                <div className="notfound -network -item" key={index}>
                  <img src={require('../../assets/images/temp/' + image.url)} alt="Rede Solidária" />
                </div>
              );
            })}

          </div>

        </article>

      }

      <article className="container section -holder center">

        <div className="logo mr-auto ml-auto">

          <NavLink strict exact to="/">
            <InlineSVG src={svgLogoSource} />
            <span className="sr-only">Conta Comigo</span>
          </NavLink>

        </div>

        <h1 className="title -median c-inverse mt-8 mb-8">
          Não conseguimos encontrar<br />
          a página que você estava buscando.
        </h1>

        <Link to="/" className="button -link -larger b-1">
          <span className="button -text">Voltar a página principal</span>
        </Link>

      </article>

    </section>
  );
};

export default NaoEncontrado;